export default __webpack_public_path__ + "static/media/Diabolical Opus.64ca7596.jpg";